import getEnv from "@/config/env";
const enviroment = getEnv("VUE_APP_ENVIRONMENT");

const accounts_prod = [
  {
    "account_id": "9ee8513b-63a0-47e0-8fc1-e190504d8247",
    "project_id": "bd448518-bccd-49b0-b12b-93bf811c4a3d",
    "mask_profile_id": "74b2ce0f-f8fe-4cff-97fa-88882e9d34e8",
    "type": "digital",
    "label": "Digital (Dial Service)"
  },
  {
    "account_id": "f73e2850-d046-48ef-9aea-ad3d4d46b2db",
    "project_id": "dd27490b-f829-475c-8095-85a8edc0dcfd",
    "mask_profile_id": "c31d379b-f619-4b86-ab44-a8484fa712fa",
    "type": "analog",
    "label": "Analog (Maira)"
  }
]

const accounts_stg = [
  {
    "account_id": "9ee8513b-63a0-47e0-8fc1-e190504d8247",
    "project_id": "df56af7d-7144-4ec0-87d2-e7139ab35e93",
    "mask_profile_id": "50b7013d-d07d-4b4e-9d09-934af15df66b",
    "type": "digital",
    "label": "Digital (Dial Service)"
  },
  {
    "account_id": "f73e2850-d046-48ef-9aea-ad3d4d46b2db",
    "project_id": "dd27490b-f829-475c-8095-85a8edc0dcfd",
    "mask_profile_id": "c31d379b-f619-4b86-ab44-a8484fa712fa",
    "type": "analog",
    "label": "Analog (Maira)"
  },
  {
    "account_id": "8d0e221d-544e-4ad5-9131-28569f6d6a37",
    "project_id": "989741bb-9dd4-492e-9fc0-c74b2c670927",
    "mask_profile_id": "154d5980-3b1b-404c-b89d-2422f2c0cba4",
    "type": "analog",
    "label": "Analog (Dev)"
  }
]

const accountList =
  enviroment === "production"
    ? accounts_prod
    : enviroment === "staging"
      ? accounts_stg
      : enviroment === "development"
        ? getEnv("VUE_APP_ACCOUNT_LIST")
          ? JSON.parse(getEnv("VUE_APP_ACCOUNT_LIST"))
          : []
        : [];

export default accountList;